import $ from 'jquery';
import int_menu from "./js/menu.js";
import int_carousel from "./js/carousel.js";
import int_accordion from "./js/accordion.js";
import int_tabbed from './js/tabbed.js';
import footerTag from './js/footer-tag.js';
import int_breadcrumb from './js/breadcrumb.js';
import int_actuality from './js/actuality.js';
import int_alert from './js/alert.js';
import int_form from './js/form.js';
// import int_search from './js/search.js';
import int_custom from './js/custom.js';
import int_toTopPage from './js/to-top.js';
int_menu();
int_carousel();
int_accordion();
int_tabbed();
footerTag();
int_breadcrumb();
int_actuality();
int_alert();
int_form();
// int_search();
int_custom();
int_toTopPage();

window.addEventListener('message', receiveMessage, false);

function receiveMessage(event) {

	if (event.origin !== window.origin) {
		return;
	}
  

	let res_data = event.data;
	if (res_data.totalResults){
		$("#result-data").html(res_data.totalResults + " résultats de recherche pour <b>" + res_data.query + "</b>" );
	}else{
		$("#result-data").html("Aucun résultat trouvé");
	}
	
	
}



